
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/base/Button';
import Input from '../../components/base/Input';
import Card from '../../components/base/Card';

export default function Auth() {
  const navigate = useNavigate();
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    phone: '',
    email: '',
    otp: ''
  });
  const [step, setStep] = useState(1); // 1: phone/email, 2: OTP verification
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    if (step === 1) {
      // Simulate sending OTP
      setTimeout(() => {
        setStep(2);
        setLoading(false);
      }, 1500);
    } else {
      // Simulate OTP verification
      setTimeout(() => {
        setLoading(false);
        if (isLogin) {
          navigate('/dashboard');
        } else {
          navigate('/registration');
        }
      }, 1500);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#E3F2FD] to-[#FFF8E1] flex flex-col">
      {/* Header */}
      <div className="bg-[#1565C0] text-white py-8 px-4 text-center">
        <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4">
          <i className="ri-briefcase-fill text-2xl text-[#1565C0]"></i>
        </div>
        <h1 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Pacifico, serif' }}>
          FutureStaff
        </h1>
        <p className="text-white/90">
          {isLogin ? 'مرحباً بعودتك' : 'انضم إلى فريق العمل'}
        </p>
      </div>

      {/* Form Container */}
      <div className="flex-1 px-4 py-6">
        <Card className="max-w-md mx-auto">
          <div className="text-center mb-6">
            <h2 className="text-xl font-bold text-[#333333] mb-2">
              {step === 1 
                ? (isLogin ? 'تسجيل الدخول' : 'إنشاء حساب جديد')
                : 'تأكيد رمز التحقق'
              }
            </h2>
            <p className="text-[#757575] text-sm">
              {step === 1 
                ? 'أدخل رقم الجوال أو البريد الإلكتروني'
                : 'تم إرسال رمز التحقق إلى رقمك'
              }
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            {step === 1 ? (
              <>
                <Input
                  label="رقم الجوال"
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  placeholder="05xxxxxxxx"
                  icon="ri-phone-line"
                  required
                />
                
                <div className="text-center text-[#757575] text-sm">أو</div>
                
                <Input
                  label="البريد الإلكتروني"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="example@email.com"
                  icon="ri-mail-line"
                />
              </>
            ) : (
              <Input
                label="رمز التحقق"
                type="text"
                name="otp"
                value={formData.otp}
                onChange={handleInputChange}
                placeholder="أدخل الرمز المكون من 6 أرقام"
                icon="ri-shield-check-line"
                maxLength={6}
                required
              />
            )}

            <Button 
              type="submit" 
              className="w-full"
              loading={loading}
            >
              {step === 1 
                ? (isLogin ? 'إرسال رمز التحقق' : 'إنشاء الحساب')
                : 'تأكيد الرمز'
              }
            </Button>
          </form>

          {step === 1 && (
            <div className="mt-6 text-center">
              <p className="text-[#757575] text-sm">
                {isLogin ? 'ليس لديك حساب؟' : 'لديك حساب بالفعل؟'}
                <button
                  onClick={() => setIsLogin(!isLogin)}
                  className="text-[#1565C0] font-medium mr-1 hover:underline"
                >
                  {isLogin ? 'إنشاء حساب جديد' : 'تسجيل الدخول'}
                </button>
              </p>
            </div>
          )}

          {step === 2 && (
            <div className="mt-4 text-center">
              <button
                onClick={() => setStep(1)}
                className="text-[#1565C0] text-sm hover:underline"
              >
                تغيير رقم الجوال
              </button>
            </div>
          )}
        </Card>
      </div>
    </div>
  );
}
